import Warehouse from '@adaptors-api/warehouse-api';
import { IMeta } from '@interfaces/imeta';
import { IWarehouse } from '@interfaces/iwarehouse';
import { isFetchingData, setMetaData, setNotification } from '@pages/base/action';
import ActionTypes from '@store/action-types';
import { EnumLoading, DataName } from '@utils/constants';
import RequestAPI from '@utils/request-api';

const setLoading = (dispatch: any) => {
  dispatch(isFetchingData(EnumLoading.SET, DataName.WAREHOUSE));
};
const unsetLoading = (dispatch: any) => {
  dispatch(isFetchingData(EnumLoading.REMOVE, DataName.WAREHOUSE));
};

export const setWarehouse = (warehouse?: IWarehouse) => ({
  warehouse,
  type: ActionTypes.PAGE_WAREHOUSE_SET_WAREHOUSE,
});

export const setWarehouseList = (warehouseList: IWarehouse[]) => ({
  warehouseList,
  type: ActionTypes.PAGE_WAREHOUSE_SET_WAREHOUSE_LIST,
});

export const fetchWarehouse = (code: string) => (dispatch: any) => {
  setLoading(dispatch);

  if (!code) {
    dispatch(setWarehouse(undefined));
    unsetLoading(dispatch);
    return;
  }

  return RequestAPI(Warehouse.getWarehouse(code))
    .then((response: any) => {
      const { data } = response.data;
      const warehouse: IWarehouse = data;
      dispatch(setWarehouse(warehouse));
      unsetLoading(dispatch);
    })
    .catch((e: Error) => {
      unsetLoading(dispatch);
    });
};

export const fetchWarehouseList = (params?: any, isSetMeta: boolean = true) => (dispatch: any) => {
  setLoading(dispatch);

  return RequestAPI(Warehouse.getWarehouses(params))
    .then((response: any) => {
      const { data, meta } = response.data;
      const warehouseList: IWarehouse[] = data;
      const metaData: IMeta = meta;
      dispatch(setWarehouseList(warehouseList));
      if (isSetMeta) {
        dispatch(setMetaData(metaData));
      }
      unsetLoading(dispatch);
    })
    .catch((e: Error) => {
      unsetLoading(dispatch);
    });
};

export const createWarehouse = (body: IWarehouse) => (dispatch: any) => {
  setLoading(dispatch);

  return RequestAPI(Warehouse.createWarehouse(body))
    .then((response: any) => {
      unsetLoading(dispatch);
      const notif: any = {
        status: response.status === 200 ? 'success' : 'error',
        title: `Buat Gudang ${response.status === 200 ? 'Sukses' : 'Gagal'}`,
        message: response.data.message,
      };
      dispatch(setNotification(notif));
    })
    .catch((e: Error) => {
      unsetLoading(dispatch);
      const notif: any = {
        status: 'error',
        title: `Buat Gudang Gagal`,
        message: e.message,
      };
      dispatch(setNotification(notif));
    });
};

export const updateWarehouse = (code: string, body: IWarehouse) => (dispatch: any) => {
  setLoading(dispatch);

  return RequestAPI(Warehouse.updateWarehouse(code, body))
    .then((response: any) => {
      unsetLoading(dispatch);
      const notif: any = {
        status: response.status === 200 ? 'success' : 'error',
        title: `Ubah Gudang ${response.status === 200 ? 'Sukses' : 'Gagal'}`,
        message: response.data.message,
      };
      dispatch(setNotification(notif));
    })
    .catch((e: Error) => {
      unsetLoading(dispatch);
      const notif: any = {
        status: 'error',
        title: `Ubah Gudang Gagal`,
        message: e.message,
      };
      dispatch(setNotification(notif));
    });
};
